<agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" (mapReady)="onMapReady($event)"
  [styles]="constant.style">

  <agm-marker [latitude]="markerData.lat" [longitude]="markerData.long" [iconUrl]="markerData.icon"></agm-marker>
</agm-map>
<!-- {{constant.style | json}} -->